import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { formatCurrency } from '../../../utils/mathUtils';
import moment from 'moment';

export const useGetColumns = () => {

    const columns = [
        {
            field: 'contrato',
            headerName: 'Contrato',
            flex: 130
        },
        {
            field: 'programa',
            headerName: 'Programa',
            flex: 120
        },
        {
            field: 'planCuidado',
            headerName: 'Plan Cuidado',
            flex: 180
        },
        {
            field: 'estadoContrato',
            headerName: 'Estado del contrato',
            flex: 100
        },
        {
            field: 'estadoAsistencial',
            headerName: 'Estado Asistencial',
            flex: 150
        },
        {
            field: 'fechaDesde',
            headerName: 'Fecha Desde',
            type: 'date',
            flex: 130
        },
        {
            field: 'fechaHasta',
            headerName: 'Fecha Hasta',
            type: 'date',
            flex: 130
        },
        {
            field: 'fechaDesdeSuspension',
            headerName: 'Fecha Desde Suspensión',
            valueGetter: (value) => {
                if (!value) return '-';
                const date = moment(value);
                return date.year() < 1500 ? '-' : date.format('DD/MM/YYYY');
            },
            flex: 150
        },
        {
            field: 'fechaHastaSuspension',
            headerName: 'Fecha Hasta Suspensión',
            valueGetter: (value) => {
                if (!value) return '-';
                const date = moment(value);
                return date.year() < 1500 ? '-' : date.format('DD/MM/YYYY');
            },
            flex: 150
        },
        {
            field: 'codigoCliente',
            headerName: 'Código Cliente',
            flex: 130
        },
        {
            field: 'cliente',
            headerName: 'Cliente',
            flex: 200
        },
        {
            field: 'precioDiario',
            headerName: 'Precio Diario',
            flex: 130,
            renderCell: (params) => {
                const value = params.value;
                return value ? formatCurrency(value) : '';
            }
        }
    ];

    const configuratedColumns = generateColumnsDefaultConfiguration(columns, true);

    return configuratedColumns;
}